import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.fill";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import color from 'tinycolor2';
import format from 'date-fns/format';
import getDay from 'date-fns/getDay';
import getYear from 'date-fns/getYear';
import parseISO from 'date-fns/parseISO';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import eachDayOfInterval from 'date-fns/eachDayOfInterval';
import formatISO from 'date-fns/formatISO';
import getMonth from 'date-fns/getMonth';
import nextDay from 'date-fns/nextDay';
import subWeeks from 'date-fns/subWeeks';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles_calendar__1s6ps {\n  max-width: 100%;\n  height: auto;\n  overflow: visible;\n}\n\n.styles_calendar__1s6ps text {\n  fill: currentColor;\n}\n\n.styles_block__1oBAV {\n  stroke: rgba(0, 0, 0, 0.1);\n  stroke-width: 1px;\n  shape-rendering: geometricPrecision;\n}\n\n.styles_footer__56qQv {\n  display: flex;\n}\n\n/*noinspection CssUnresolvedCustomProperty*/\n@keyframes styles_loadingAnimation__1DJJ8 {\n  0% {\n    fill: var(--react-activity-calendar-loading);\n  }\n  50% {\n    fill: var(--react-activity-calendar-loading-active);\n  }\n  100% {\n    fill: var(--react-activity-calendar-loading);\n  }\n}\n";
var styles = {
  "calendar": "styles_calendar__1s6ps",
  "block": "styles_block__1oBAV",
  "footer": "styles_footer__56qQv",
  "loadingAnimation": "styles_loadingAnimation__1DJJ8"
};
styleInject(css_248z);
var NAMESPACE = 'react-activity-calendar';
var MIN_DISTANCE_MONTH_LABELS = 2;
var DEFAULT_THEME = createCalendarTheme('#042a33');

function groupByWeeks(days) // 0 = Sunday
{
  var weekStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (days.length === 0) {
    return [];
  } // Determine the first date of the calendar. If the first contribution date is
  // not specified week day the desired day one week earlier will be selected.


  var firstDate = parseISO(days[0].date);
  var firstCalendarDate = getDay(firstDate) === weekStart ? firstDate : subWeeks(nextDay(firstDate, weekStart), 1); // In order to correctly group contributions by week it is necessary to left pad the list

  var paddedDays = [].concat(_toConsumableArray(Array(differenceInCalendarDays(firstDate, firstCalendarDate)).fill(undefined)), _toConsumableArray(days));
  return Array(Math.ceil(paddedDays.length / 7)).fill(undefined).map(function (_, calendarWeek) {
    return paddedDays.slice(calendarWeek * 7, calendarWeek * 7 + 7);
  });
}

function getMonthLabels(weeks) {
  var monthNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_MONTH_LABELS;
  return weeks.reduce(function (labels, week, index) {
    var firstWeekDay = week.find(function (day) {
      return day !== undefined;
    });

    if (!firstWeekDay) {
      throw new Error("Unexpected error: Week is empty: [".concat(week, "]"));
    }

    var month = monthNames[getMonth(parseISO(firstWeekDay.date))];
    var prev = labels[labels.length - 1];

    if (index === 0 || prev.text !== month) {
      return [].concat(_toConsumableArray(labels), [{
        x: index,
        y: 0,
        text: month
      }]);
    }

    return labels;
  }, []).filter(function (label, index, labels) {
    if (index === 0) {
      return labels[1] && labels[1].x - label.x > MIN_DISTANCE_MONTH_LABELS;
    }

    return true;
  });
}

function createCalendarTheme(baseColor) {
  var emptyColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : color('white').darken(8).toHslString();
  var base = color(baseColor);

  if (!base.isValid()) {
    return DEFAULT_THEME;
  }

  return {
    level4: base.setAlpha(0.92).toHslString(),
    level3: base.setAlpha(0.76).toHslString(),
    level2: base.setAlpha(0.6).toHslString(),
    level1: base.setAlpha(0.44).toHslString(),
    level0: emptyColor
  };
}

function getTheme(theme, color) {
  if (theme) {
    return Object.assign({}, DEFAULT_THEME, theme);
  }

  if (color) {
    return createCalendarTheme(color);
  }

  return DEFAULT_THEME;
}

function getClassName(name, styles) {
  if (styles) {
    return "".concat(NAMESPACE, "__").concat(name, " ").concat(styles);
  }

  return "".concat(NAMESPACE, "__").concat(name);
}

function generateEmptyData() {
  var year = new Date().getFullYear();
  var days = eachDayOfInterval({
    start: new Date(year, 0, 1),
    end: new Date(year, 11, 31)
  });
  return days.map(function (date) {
    return {
      date: formatISO(date, {
        representation: 'date'
      }),
      count: 0,
      level: 0
    };
  });
}

var DEFAULT_MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var DEFAULT_WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var DEFAULT_LABELS = {
  months: DEFAULT_MONTH_LABELS,
  weekdays: DEFAULT_WEEKDAY_LABELS,
  totalCount: '{{count}} contributions in {{year}}',
  legend: {
    less: 'Less',
    more: 'More'
  }
};

var ActivityCalendar = function ActivityCalendar(_ref) {
  var _additionalStyles;

  var data = _ref.data,
      _ref$blockMargin = _ref.blockMargin,
      blockMargin = _ref$blockMargin === void 0 ? 4 : _ref$blockMargin,
      _ref$blockRadius = _ref.blockRadius,
      blockRadius = _ref$blockRadius === void 0 ? 2 : _ref$blockRadius,
      _ref$blockSize = _ref.blockSize,
      blockSize = _ref$blockSize === void 0 ? 12 : _ref$blockSize,
      children = _ref.children,
      _ref$color = _ref.color,
      color$1 = _ref$color === void 0 ? undefined : _ref$color,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'MMM do, yyyy' : _ref$dateFormat,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$hideColorLegend = _ref.hideColorLegend,
      hideColorLegend = _ref$hideColorLegend === void 0 ? false : _ref$hideColorLegend,
      _ref$hideMonthLabels = _ref.hideMonthLabels,
      hideMonthLabels = _ref$hideMonthLabels === void 0 ? false : _ref$hideMonthLabels,
      _ref$hideTotalCount = _ref.hideTotalCount,
      hideTotalCount = _ref$hideTotalCount === void 0 ? false : _ref$hideTotalCount,
      labelsProp = _ref.labels,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$showWeekdayLabel = _ref.showWeekdayLabels,
      showWeekdayLabels = _ref$showWeekdayLabel === void 0 ? false : _ref$showWeekdayLabel,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      themeProp = _ref.theme,
      _ref$weekStart = _ref.weekStart,
      weekStart = _ref$weekStart === void 0 ? 0 : _ref$weekStart;

  var _data$;

  if (loading) {
    data = generateEmptyData();
  }

  if (data.length === 0) {
    return null;
  }

  var weeks = groupByWeeks(data, weekStart);
  var totalCount = data.reduce(function (sum, day) {
    return sum + day.count;
  }, 0);
  var year = getYear(parseISO((_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.date));
  var theme = getTheme(themeProp, color$1);
  var labels = Object.assign({}, DEFAULT_LABELS, labelsProp);
  var textHeight = hideMonthLabels ? 0 : fontSize + 2 * blockMargin;

  function getDimensions() {
    return {
      width: weeks.length * (blockSize + blockMargin) - blockMargin,
      height: textHeight + (blockSize + blockMargin) * 7 - blockMargin
    };
  }

  function getTooltipMessage(contribution) {
    var date = format(parseISO(contribution.date), dateFormat);
    return "<strong>".concat(contribution.count, " contributions</strong> on ").concat(date);
  }

  function renderLabels() {
    var style = {
      fontSize: fontSize
    };

    if (!showWeekdayLabels && hideMonthLabels) {
      return null;
    }

    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null, showWeekdayLabels &&
      /*#__PURE__*/
      React.createElement("g", {
        className: getClassName('legend-weekday'),
        style: style
      }, weeks[1].map(function (day, y) {
        if (!day || y % 2 === 0) {
          return null;
        }

        var dayIndex = getDay(parseISO(day.date));
        return (
          /*#__PURE__*/
          React.createElement("text", {
            x: -2 * blockMargin,
            y: textHeight + (fontSize / 2 + blockMargin) + (blockSize + blockMargin) * y,
            textAnchor: "end",
            key: day.date
          }, labels.weekdays ? labels.weekdays[dayIndex] : DEFAULT_WEEKDAY_LABELS[dayIndex])
        );
      })), !hideMonthLabels &&
      /*#__PURE__*/
      React.createElement("g", {
        className: getClassName('legend-month'),
        style: style
      }, getMonthLabels(weeks, labels.months).map(function (_ref2, index, labels) {
        var text = _ref2.text,
            x = _ref2.x;

        // Skip the first month label if there's not enough space to the next one
        if (index === 0 && labels[1] && labels[1].x - x <= MIN_DISTANCE_MONTH_LABELS) {
          return null;
        }

        return (
          /*#__PURE__*/
          React.createElement("text", {
            x: (blockSize + blockMargin) * x,
            alignmentBaseline: "hanging",
            key: x
          }, text)
        );
      })))
    );
  }

  function renderBlocks() {
    return weeks.map(function (week, weekIndex) {
      return week.map(function (day, dayIndex) {
        if (!day) {
          return null;
        }

        var style = loading ? {
          animation: "".concat(styles.loadingAnimation, " 1.5s ease-in-out infinite"),
          animationDelay: "".concat(weekIndex * 20 + dayIndex * 20, "ms")
        } : undefined;
        return (
          /*#__PURE__*/
          React.createElement("rect", {
            x: 0,
            y: textHeight + (blockSize + blockMargin) * dayIndex,
            width: blockSize,
            height: blockSize,
            fill: theme["level".concat(day.level)],
            rx: blockRadius,
            ry: blockRadius,
            className: styles.block,
            "data-date": day.date,
            "data-tip": children ? getTooltipMessage(day) : undefined,
            key: day.date,
            style: style
          })
        );
      });
    }).map(function (week, x) {
      return (
        /*#__PURE__*/
        React.createElement("g", {
          key: x,
          transform: "translate(".concat((blockSize + blockMargin) * x, ", 0)")
        }, week)
      );
    });
  }

  function renderFooter() {
    var _labels$legend$less, _labels$legend, _labels$legend$more, _labels$legend2;

    if (hideTotalCount && hideColorLegend) {
      return null;
    }

    return (
      /*#__PURE__*/
      React.createElement("footer", {
        className: getClassName('footer', styles.footer),
        style: {
          marginTop: blockMargin,
          fontSize: fontSize
        }
      }, loading &&
      /*#__PURE__*/
      React.createElement("div", null, "\xA0"), !loading && !hideTotalCount &&
      /*#__PURE__*/
      React.createElement("div", {
        className: getClassName('count')
      }, labels.totalCount ? labels.totalCount.replace('{{count}}', String(totalCount)).replace('{{year}}', String(year)) : "".concat(totalCount, " contributions in ").concat(year)), !loading && !hideColorLegend &&
      /*#__PURE__*/
      React.createElement("div", {
        className: getClassName('legend-colors'),
        style: {
          marginLeft: 'auto'
        }
      },
      /*#__PURE__*/
      React.createElement("span", {
        style: {
          marginRight: '0.5em'
        }
      }, (_labels$legend$less = labels === null || labels === void 0 ? void 0 : (_labels$legend = labels.legend) === null || _labels$legend === void 0 ? void 0 : _labels$legend.less) !== null && _labels$legend$less !== void 0 ? _labels$legend$less : 'Less'), Array(5).fill(undefined).map(function (_, index) {
        return (
          /*#__PURE__*/
          React.createElement("svg", {
            width: blockSize,
            height: blockSize,
            key: index,
            style: {
              margin: '0 0.1em'
            }
          },
          /*#__PURE__*/
          React.createElement("rect", {
            width: blockSize,
            height: blockSize,
            fill: theme["level".concat(index)],
            rx: blockRadius,
            ry: blockRadius
          }))
        );
      }),
      /*#__PURE__*/
      React.createElement("span", {
        style: {
          marginLeft: '0.5em'
        }
      }, (_labels$legend$more = labels === null || labels === void 0 ? void 0 : (_labels$legend2 = labels.legend) === null || _labels$legend2 === void 0 ? void 0 : _labels$legend2.more) !== null && _labels$legend$more !== void 0 ? _labels$legend$more : 'More')))
    );
  }

  var _getDimensions = getDimensions(),
      width = _getDimensions.width,
      height = _getDimensions.height;

  var additionalStyles = (_additionalStyles = {
    width: width,
    maxWidth: '100%'
  }, _defineProperty(_additionalStyles, "--".concat(NAMESPACE, "-loading"), theme.level0), _defineProperty(_additionalStyles, "--".concat(NAMESPACE, "-loading-active"), color(theme.level0).darken(8).toString()), _additionalStyles);
  return (
    /*#__PURE__*/
    React.createElement("article", {
      className: NAMESPACE,
      style: _objectSpread(_objectSpread({}, style), additionalStyles)
    },
    /*#__PURE__*/
    React.createElement("svg", {
      width: width,
      height: height,
      viewBox: "0 0 ".concat(width, " ").concat(height),
      className: getClassName('calendar', styles.calendar)
    }, !loading && renderLabels(), renderBlocks()), renderFooter(), children)
  );
};

var Skeleton = function Skeleton(props) {
  return (
    /*#__PURE__*/
    React.createElement(ActivityCalendar, _extends({
      data: []
    }, props))
  );
};

export { Skeleton, createCalendarTheme, ActivityCalendar as default };